module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    page_0002_login_expired\n  ")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('div', {
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('center', [_vm._v("\n        30分以上ログインが確認出来なかったため、切断されました。"), _c('br'), _vm._v("\n        以下のボタンをクリックし、ログイン画面を再度開いてください。\n      ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_c('center', [_c('router-link', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "tag": "button",
      "to": "/",
      "type": "button"
    }
  }, [_vm._v("ログイン画面へ")])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#ffffff",
      "font-size": "30px",
      "padding": "27px 50px",
      "font-weight": "800",
      "background": "#5b9bd5"
    }
  }, [_vm._v("\n    ソフトウェアライセンス管理\n    "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#ffffff"
    }
  }, [_vm._v("e-sma")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61934364","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0002_login_expired.vue
// module id = 1009
// module chunks = 0